import React, {useState} from 'react';

import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';
import './ResultQueryCreate.css';
import Line from '../../graph/line/Line';
import BuzzlistTable from '../../buzzlist-table/BuzzlistTable';

const ResultQueryCreate = React.memo((props) => {
  const [volumeTab, setVolumeTab] = useState('button tabBlue_on');
  const [buzzlistTab, setBuzzlistTab] = useState('button tabBlue_off');

  const handleTabClick = (e) => {
    if(e.target.getAttribute('name')=="volume-tab"){
      setVolumeTab('button tabBlue_on');
      setBuzzlistTab('button tabBlue_off');
    }
    else if(e.target.getAttribute('name')=='buzzlist-tab'){
      setVolumeTab('button tabBlue_off');
      setBuzzlistTab('button tabBlue_on');
    }
  }
  const QueryLine = React.memo((props) => {
    return (
      <Line width={props.width} height={props.height} data={props.data}/>
      )
  }, [props.resultData])

  return (
    <>
      <div className="queryTabBox">
        <a name="volume-tab" onClick={handleTabClick} className={volumeTab}>Volume</a>
        &nbsp;
        <a name="buzzlist-tab" onClick={handleTabClick} className={buzzlistTab}>Buzzlist</a>
      </div>
      <div className="queryDateBox">
        {/* <DateRangePickerWithCalendar authed={true} isOpen={false} minDate={props.minDate} onChange={props.handleDate} value={props.dateRange} /> */}
        {/* <DateRangePickerWithCalendar authed={true} isOpen={false} minDate={props.minDate} onChange={props.handleDate} value={props.dateRange} /> */}
        <DateRangePickerWithCalendar authed={true} isOpen={false} minDate={props.minDate} onChange={props.handleDate} value={props.dateRange} />
        &nbsp;
        {/* <a className="button grayS filter" style={{cursor:'pointer'}} onClick={props.handleRefreshBtn}>Refresh</a> */}
        <a className="button purple" onClick={props.handleRefreshBtn}>새로고침</a>
      </div>
      <div className="graphBox">
        {React.useMemo(()=>{
          return(
            <>
              {volumeTab=="button tabBlue_on" ?
                <>
                  {props.resultData.volume ?
                    <QueryLine width="100%" height={500} data={props.resultData.volume}/>
                    : <>Line loading</>}
                </>
              : <>
                  {props.resultData.buzzlist ?
                    <BuzzlistTable resultData={props.resultData.buzzlist} />
                  : <>Buzzlist loading</>}
              </>
              }
            </>
          )
        }, [props.resultData, volumeTab, buzzlistTab])}
        
      </div>
    </>
  )
});

export default ResultQueryCreate;